import { Flex } from '@servicetitan/anvil2';
import { PropsWithChildren } from 'react';
import { ReviewingFooterStore } from '@servicetitan/financing-application-workflow-shared';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';
import { useBreakpoint } from '@servicetitan/financing-utils-shared';

export const DefaultLayout = ({ children }: PropsWithChildren) => {
    const { showApprovedFooter } = ReviewingFooterStore.useStore();
    const { DoneButton } = WorkflowButtonsStore.useStore();
    const screenSize = useBreakpoint();
    const isNarrowScreen = screenSize.isXs || screenSize.isSm;

    return (
        <Flex direction="column" gap="8" style={{ minHeight: '100%', width: '100%' }}>
            <div style={{ flexGrow: 1 }}>{children}</div>
            {showApprovedFooter && (
                <div style={{ flexGrow: 0 }}>
                    <Flex justifyContent={isNarrowScreen ? 'stretch' : 'flex-end'}>
                        <DoneButton style={isNarrowScreen ? { width: '100%' } : {}} />
                    </Flex>
                </div>
            )}
        </Flex>
    );
};
